import { Component, HostListener, OnInit } from '@angular/core';
import { CompanyParamsService } from '../../services/company-params.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'is-what';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Observable, Subject, delay, fromEvent, tap } from 'rxjs';
import { AuthLoginService } from 'src/app/modules/auth/services/auth-login.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  isLogged: boolean = false;
  isOpen: boolean = false;
  username: string = ''
  mainColor: any;

  constructor(
    public companyParamsService: CompanyParamsService,
    public router: Router,
    public localStorageService: LocalStorageService,
    public authLoginService: AuthLoginService
  ) { }

  ngOnInit(): void {
    this.mainColor = "#"+this.companyParamsService.getMainColor();
    this.checkLoggedIn();
    this.localStorageService.watchStorage().pipe(delay(1500)).subscribe(() => {
      this.checkLoggedIn();
    });

  }

  logout(): void {
    this.localStorageService.removeData(this.companyParamsService.getCode() + '-loginToken');
    this.router.navigate(['search']);
    this.isLogged = false;
    this.isOpen = false;
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  checkLoggedIn() {
    this.isLogged = !isNullOrUndefined(localStorage.getItem(this.companyParamsService.getCode() + '-loginToken'));
    if (this.isLogged) {
      let token = localStorage.getItem(this.companyParamsService.getCode() + '-loginToken');
      this.username = this.authLoginService.decodeToken(token!)!.name;
    }
  }

}
